var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.58579 1.25278C2.96086 0.877706 3.46957 0.666992 4 0.666992H9.33333C9.51014 0.666992 9.67971 0.73723 9.80474 0.862254L13.8047 4.86225C13.9298 4.98728 14 5.15685 14 5.33366V13.3337C14 13.8641 13.7893 14.3728 13.4142 14.7479C13.0391 15.1229 12.5304 15.3337 12 15.3337H4C3.46957 15.3337 2.96086 15.1229 2.58579 14.7479C2.21071 14.3728 2 13.8641 2 13.3337V2.66699C2 2.13656 2.21071 1.62785 2.58579 1.25278ZM4 2.00033C3.82319 2.00033 3.65362 2.07056 3.5286 2.19559C3.40357 2.32061 3.33333 2.49018 3.33333 2.66699V13.3337C3.33333 13.5105 3.40357 13.68 3.5286 13.8051C3.65362 13.9301 3.82319 14.0003 4 14.0003H12C12.1768 14.0003 12.3464 13.9301 12.4714 13.8051C12.5964 13.68 12.6667 13.5105 12.6667 13.3337V5.6098L9.05719 2.00033H4Z",
    fill: "#7E716D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33333 0.666992C9.70152 0.666992 10 0.965469 10 1.33366V4.66699H13.3333C13.7015 4.66699 14 4.96547 14 5.33366C14 5.70185 13.7015 6.00033 13.3333 6.00033H9.33333C8.96514 6.00033 8.66667 5.70185 8.66667 5.33366V1.33366C8.66667 0.965469 8.96514 0.666992 9.33333 0.666992Z",
    fill: "#7E716D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66667 8.66699C4.66667 8.2988 4.96514 8.00033 5.33333 8.00033H10.6667C11.0349 8.00033 11.3333 8.2988 11.3333 8.66699C11.3333 9.03518 11.0349 9.33366 10.6667 9.33366H5.33333C4.96514 9.33366 4.66667 9.03518 4.66667 8.66699Z",
    fill: "#7E716D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66667 11.3337C4.66667 10.9655 4.96514 10.667 5.33333 10.667H10.6667C11.0349 10.667 11.3333 10.9655 11.3333 11.3337C11.3333 11.7018 11.0349 12.0003 10.6667 12.0003H5.33333C4.96514 12.0003 4.66667 11.7018 4.66667 11.3337Z",
    fill: "#7E716D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66667 6.00033C4.66667 5.63214 4.96514 5.33366 5.33333 5.33366H6.66667C7.03486 5.33366 7.33333 5.63214 7.33333 6.00033C7.33333 6.36852 7.03486 6.66699 6.66667 6.66699H5.33333C4.96514 6.66699 4.66667 6.36852 4.66667 6.00033Z",
    fill: "#7E716D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentMenuIcon);
export default __webpack_public_path__ + "static/media/document-menu-icon.a05286bc950987ad94e4affe1b13b023.svg";
export { ForwardRef as ReactComponent };